var map = {
	"./match_22_1.jpg": 5045,
	"./match_22_2.jpg": 8794,
	"./match_22_3.jpg": 4631,
	"./match_22_4.jpg": 8636,
	"./match_22_5.jpg": 9689,
	"./match_22_6.jpg": 2574,
	"./match_22_7.jpg": 619,
	"./match_22_8.jpg": 9008
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1879;